module.exports = __webpack_public_path__ + "img/idea-stage.06745413.png";